import {Location} from '@angular/common';

export function cleanUpUrl(url: string, location: Location): void {
  return location.go(url.split('?')[0]);
}
